export default "/_next/static/videos/5ea20532acaba6027c27dc71a4533cad.mp4";